import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import uuid from 'uuid'
import { Title } from 'components/layout'
import { ConfigKey } from 'containers/forms/configuration'
import { ConfigurationKeySetModal } from 'components/modals'
import { CONFIGURATION_KEYS } from 'constants/enums'

export default class PaymentThreshold extends Component {
  static propTypes = {
    configuration: PropTypes.object,
    activeOrganization: PropTypes.object,
    isSameLevel: PropTypes.bool,
    modal: PropTypes.func,
    onUpdateConfigKey: PropTypes.func,
    onResetConfigKey: PropTypes.func,
    reset: PropTypes.func,
    change: PropTypes.func,
    initialize: PropTypes.func,
    isConfigUpdating: PropTypes.bool,
    handleSubmit: PropTypes.func
  }

  state = {
    config: {}
  }

  key = uuid.v1()

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  render() {
    const {
      activeOrganization,
      isSameLevel,
      handleSubmit,
      configuration
    } = this.props

    return (
      <div>
        <Title h2>Payment link expiration threshold</Title>

        <ConfigKey
          config={
            configuration.values[CONFIGURATION_KEYS.paymentLinkThreshold.id]
          }
          onConfigEdit={this.handleChangeConfig}
          activeOrganization={activeOrganization}
          isSameLevel={isSameLevel}
          compact
        />

        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
        />
      </div>
    )
  }
}
